// Generat automat din README.md - Adaptat pentru Botez de poveste

// Mock data pentru companie mică specializată în produse pentru botez
export const mockData = {
  // Contabilitate - Facturi pentru produse botez
  invoices: [
    { id: 'INV-001', client: 'Familia Popescu', amount: '850.00 RON', status: 'Plătită', date: '2024-03-15', description: 'Tort botez + decorațiuni' },
    { id: 'INV-002', client: 'Familia Ionescu', amount: '1,200.00 RON', status: 'În așteptare', date: '2024-03-16', description: 'Pachet complet botez' },
    { id: 'INV-003', client: 'Familia Georgescu', amount: '650.00 RON', status: 'Expirată', date: '2024-03-10', description: 'Lumanari și hainute botez' }
  ],

  // HR - Un singur angajat - Margarit Alexandru Florian
  employees: [
    { 
      id: 1, 
      name: 'Margarit Alexandru Florian', 
      position: 'Proprietar & Manager General', 
      department: 'Management', 
      status: 'Activ', 
      startDate: '2023-01-15',
      email: 'margarit.alexandru@botezdepoveste.ro',
      phone: '0721456789',
      salary: '4500 RON',
      avatar: '/avatars/margarit.jpg',
      skills: ['Design Torturi', 'Management Comenzi', 'Atenție la Client', 'Marketing Digital', 'Decorațiuni Artizanale'],
      performance: {
        goals: [
          { id: 1, title: 'Creșterea vânzărilor cu 25%', progress: 78, deadline: '2024-12-31', status: 'În progres' },
          { id: 2, title: 'Implementare sistem online comenzi', progress: 45, deadline: '2024-06-30', status: 'În progres' },
          { id: 3, title: 'Diversificarea gamei de produse', progress: 90, deadline: '2024-04-15', status: 'Aproape finalizat' }
        ],
        rating: 4.8,
        reviews: [
          { date: '2024-03-01', reviewer: 'Auto-evaluare', rating: 5, comment: 'Performanță excelentă în managementul comenzilor și relația cu clienții' },
          { date: '2024-02-15', reviewer: 'Client Familia Popescu', rating: 5, comment: 'Servicii excepționale, atenție la detalii' }
        ]
      },
      workingHours: {
        monday: '09:00-17:00',
        tuesday: '09:00-17:00', 
        wednesday: '09:00-17:00',
        thursday: '09:00-17:00',
        friday: '09:00-17:00',
        saturday: '10:00-14:00',
        sunday: 'Liber'
      }
    }
  ],

  vacations: [
    { id: 1, employee: 'Margarit Alexandru Florian', startDate: '2024-07-15', endDate: '2024-07-29', days: 14, status: 'Planificat', type: 'Concediu de odihnă', requestDate: '2024-02-20', approvedBy: 'Auto-aprobat', reason: 'Concediu de vară planificat' },
    { id: 2, employee: 'Margarit Alexandru Florian', startDate: '2024-04-29', endDate: '2024-05-03', days: 5, status: 'Aprobat', type: 'Concediu de Paște', requestDate: '2024-03-01', approvedBy: 'Auto-aprobat', reason: 'Sărbători de Paște' }
  ],

  // CRM - Clienți pentru produse botez specializate
  customers: [
    { 
      id: 1, 
      name: 'Familia Popescu', 
      contactPerson: 'Ana Popescu',
      email: 'ana.popescu@gmail.com', 
      phone: '0721234567', 
      status: 'Client fidel', 
      lastContact: '2024-03-15', 
      orders: 5, 
      totalSpent: '3,400 RON', 
      preferredProducts: 'Torturi personalizate',
      childName: 'Andrei Popescu',
      childBirthDate: '2024-01-15',
      baptismDate: '2024-03-15',
      notes: 'Preferă teme cu îngeri și culori pastel. Foarte satisfăcuți de servicii.',
      tier: 'VIP',
      source: 'Recomandare',
      address: 'Str. Florilor 15, București'
    },
    { 
      id: 2, 
      name: 'Familia Ionescu', 
      contactPerson: 'Maria Ionescu',
      email: 'maria.ionescu@yahoo.ro', 
      phone: '0731234567', 
      status: 'Client nou', 
      lastContact: '2024-03-12', 
      orders: 1, 
      totalSpent: '1,200 RON', 
      preferredProducts: 'Pachete complete',
      childName: 'Sofia Ionescu',
      childBirthDate: '2024-02-20',
      baptismDate: '2024-04-20',
      notes: 'Prima comandă, interesată de pachete all-inclusive.',
      tier: 'Regular',
      source: 'Facebook',
      address: 'Bd. Unirii 45, București'
    },
    { 
      id: 3, 
      name: 'Familia Georgescu', 
      contactPerson: 'Ion Georgescu',
      email: 'ion.georgescu@gmail.com', 
      phone: '0741234567', 
      status: 'Prospect', 
      lastContact: '2024-03-10', 
      orders: 0, 
      totalSpent: '0 RON', 
      preferredProducts: 'În evaluare',
      childName: 'Alexandru Georgescu',
      childBirthDate: '2024-04-01',
      baptismDate: 'Nepătratată',
      notes: 'Interesat de luminări și hăinuțe tradiționale.',
      tier: 'Prospect',
      source: 'Google Search',
      address: 'Str. Mihai Viteazu 22, Ploiești'
    },
    { 
      id: 4, 
      name: 'Familia Marinescu', 
      contactPerson: 'Elena Marinescu',
      email: 'elena.marinescu@outlook.com', 
      phone: '0751234567', 
      status: 'Client fidel', 
      lastContact: '2024-03-14', 
      orders: 3, 
      totalSpent: '2,100 RON', 
      preferredProducts: 'Decorațiuni artizanale',
      childName: 'Maria Marinescu',
      childBirthDate: '2024-01-10',
      baptismDate: '2024-03-10',
      notes: 'Appreciate decorațiunile handmade și mărturiile personalizate.',
      tier: 'Premium',
      source: 'Recomandare',
      address: 'Str. Primaverii 8, București'
    }
  ],

  // Vânzări - Produse pentru botez
  sales: [
    { id: 1, product: 'Tort Botez Personalizat', quantity: 1, amount: '450.00 RON', date: '2024-03-15', client: 'Familia Popescu', category: 'Torturi' },
    { id: 2, product: 'Set Lumanari Botez', quantity: 2, amount: '180.00 RON', date: '2024-03-14', client: 'Familia Ionescu', category: 'Lumanari' },
    { id: 3, product: 'Hainute Botez (set complet)', quantity: 1, amount: '320.00 RON', date: '2024-03-13', client: 'Familia Georgescu', category: 'Textile' },
    { id: 4, product: 'Decorațiuni Mesa Botez', quantity: 1, amount: '250.00 RON', date: '2024-03-12', client: 'Familia Marinescu', category: 'Decorațiuni' },
    { id: 5, product: 'Marturii Botez Personalizate', quantity: 50, amount: '300.00 RON', date: '2024-03-11', client: 'Familia Popescu', category: 'Marturii' }
  ],

  // Inventar - Produse și materiale pentru botez
  inventory: [
    { id: 1, product: 'Fondant alb (kg)', quantity: 15, minStock: 5, status: 'În stoc', location: 'Frigider', category: 'Ingrediente torturi', price: '25 RON/kg' },
    { id: 2, product: 'Lumânări albe botez', quantity: 3, minStock: 10, status: 'Stoc redus', location: 'Depozit decorațiuni', category: 'Lumânări', price: '45 RON/buc' },
    { id: 3, product: 'Haine botez 0-6 luni', quantity: 8, minStock: 5, status: 'În stoc', location: 'Dulap textile', category: 'Îmbrăcăminte', price: '120 RON/set' },
    { id: 4, product: 'Figurine tort (îngeri)', quantity: 12, minStock: 8, status: 'În stoc', location: 'Cutii decorațiuni', category: 'Decorațiuni tort', price: '35 RON/buc' },
    { id: 5, product: 'Cutii marturii (roz/albastru)', quantity: 45, minStock: 20, status: 'În stoc', location: 'Depozit ambalaje', category: 'Ambalaje', price: '3 RON/buc' },
    { id: 6, product: 'Panglici satin (diverse culori)', quantity: 2, minStock: 5, status: 'Stoc critic', location: 'Sertare materiale', category: 'Materiale decorare', price: '15 RON/rolă' }
  ],

  // Marketing - Campanii pentru produse botez
  campaigns: [
    { id: 1, name: 'Campanie Primăvară Botezuri 2024', type: 'Facebook Ads', status: 'Activă', reach: '12,500', conversion: '15.8%', budget: '800 RON', target: 'Părinți 25-35 ani' },
    { id: 2, name: 'Promovare Torturi Personalizate', type: 'Instagram', status: 'Activă', reach: '8,300', conversion: '12.3%', budget: '500 RON', target: 'Mame gravide și proaspete' },
    { id: 3, name: 'Pachete Complete Botez', type: 'Google Ads', status: 'Planificată', reach: '5,000', conversion: '0%', budget: '600 RON', target: 'Familie cu venit mediu-ridicat' },
    { id: 4, name: 'Marturii Artizanale', type: 'Email Marketing', status: 'În pregătire', reach: '2,100', conversion: '0%', budget: '150 RON', target: 'Clienți existenți' }
  ],

  // Securitate - Pentru o afacere mică
  threats: [
    { id: 1, type: 'Tentativă login site web', severity: 'Scăzută', ip: '192.168.1.100', timestamp: '2024-03-15 14:30', status: 'Monitorizat', description: 'Login eșuat pe admin WordPress' },
    { id: 2, type: 'Spam în formular contact', severity: 'Foarte scăzută', ip: '10.0.0.50', timestamp: '2024-03-15 12:15', status: 'Blocat automat', description: 'Mesaj spam în formularul de contact' }
  ],

  // Produse specializate pentru botez
  products: [
    {
      id: 1,
      name: 'Tort Botez Personalizat',
      category: 'Torturi',
      price: '450 RON',
      description: 'Tort personalizat cu tema și culori la alegere, decorat cu figurine și mesaj special',
      inStock: true,
      estimatedTime: '3-5 zile',
      images: ['tort1.jpg', 'tort2.jpg'],
      customizable: true
    },
    {
      id: 2,
      name: 'Set Lumânări Botez Tradiționale',
      category: 'Lumânări',
      price: '85 RON',
      description: 'Set lumânări albe pentru ceremonial, cu decorațiuni florale și panglici',
      inStock: true,
      estimatedTime: '1-2 zile',
      images: ['lumanari1.jpg'],
      customizable: false
    },
    {
      id: 3,
      name: 'Costum Botez Băieți (0-12 luni)',
      category: 'Îmbrăcăminte',
      price: '180 RON',
      description: 'Costum elegant pentru băieți, include cămeșuță, pantaloni și papion',
      inStock: true,
      estimatedTime: 'Disponibil imediat',
      sizes: ['0-3 luni', '3-6 luni', '6-9 luni', '9-12 luni'],
      customizable: true
    },
    {
      id: 4,
      name: 'Rochița Botez Fete (0-12 luni)',
      category: 'Îmbrăcăminte',
      price: '220 RON',
      description: 'Rochița albă cu broderii fine și accesorii incluse (bentiță, șosete)',
      inStock: false,
      estimatedTime: '5-7 zile',
      sizes: ['0-3 luni', '3-6 luni', '6-9 luni', '9-12 luni'],
      customizable: true
    },
    {
      id: 5,
      name: 'Decorațiuni Masa Botez',
      category: 'Decorațiuni',
      price: '320 RON',
      description: 'Set complet decorațiuni pentru masa principală: fețe de masă, ghirlande, baloane, centerpiece',
      inStock: true,
      estimatedTime: '2-3 zile',
      customizable: true
    },
    {
      id: 6,
      name: 'Marturii Personalizate (set 50 buc)',
      category: 'Marturii',
      price: '275 RON',
      description: 'Marturii handmade cu numele copilului și data botezului, ambalate elegant',
      inStock: true,
      estimatedTime: '4-6 zile',
      minOrder: 25,
      customizable: true
    }
  ],

  // Website
  analytics: [
    { metric: 'Vizitatori unici', value: '1,245', change: '+12%', period: 'Această lună' },
    { metric: 'Pagini vizualizate', value: '4,567', change: '+8%', period: 'Această lună' },
    { metric: 'Rata de conversie', value: '3.2%', change: '+0.5%', period: 'Această lună' }
  ]
};

// Helper functions
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('ro-RO', {
    style: 'currency',
    currency: 'RON'
  }).format(amount);
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('ro-RO');
};

export const getStatusColor = (status) => {
  const colors = {
    'Activ': 'success',
    'Activă': 'success',
    'Plătită': 'success',
    'Aprobat': 'success',
    'În stoc': 'success',
    'În așteptare': 'warning',
    'Planificată': 'warning',
    'Stoc redus': 'warning',
    'Concediu': 'info',
    'Monitorizat': 'info',
    'Prospecte': 'info',
    'Expirată': 'error',
    'Investigat': 'error'
  };
  return colors[status] || 'default';
};